export function sanitizeLessonText(input?: string): string {
  if (typeof input !== "string") return "";

  return (
    input
      // Literal escaped sequences from backend/editor payloads
      .replace(/\\r\\n/g, "\n")
      .replace(/\\n/g, "\n")
      .replace(/\\r/g, "\n")
      // Real CRLF/CR normalization
      .replace(/\r\n/g, "\n")
      .replace(/\r/g, "\n")
      // Remove non-printable control chars except TAB/LF
      // eslint-disable-next-line no-control-regex -- intentional strip of C0 controls
      .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, "")
      // Remove lone trailing backslashes at line ends (common editor artifact)
      .replace(/\\+$/gm, "")
      // Collapse lines that only contain slashes/spaces
      .replace(/^[ \t]*\\+[ \t]*$/gm, "")
  );
}

